import React from "react";
import "../css/Home.css";
import { Container, Row } from "react-bootstrap";
import Fondo from "../imagenes/login2.png";

const Home = () => {
  return (
    <>
      <div
        className="background-container"
        style={{
          backgroundImage: `url(${Fondo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh", // que abarque toda la altura de la pantalla
          width: "100%",       // que use todo el ancho
          margin: 0,
          padding: 0,
          display: "flex",
          alignItems: "center",     // centra verticalmente
          justifyContent: "center", // centra horizontalmente
          flexDirection: "column",  // apila contenido verticalmente
        }}
      >
        <Container>
          <Row>
            <div className="col"
            style={{
              marginLeft: "auto",
              textAlign: "right",
              maxWidth: "500px",
            }}
            >
              <p style={{ color: "white", fontSize: "25px", fontWeight: "bold" }}>Aquí puedes conocer los procesos de:</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Estructura Interna</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Proceso Comercial</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Operaciones</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Ingeniería</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Administración y Finanzas</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Formación</p>
              <p style={{ color: "white", fontWeight: "bold" }}>- Tickets</p>
              <br></br>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Home;
